module.exports = __webpack_public_path__ + "media/e3600797d5a6481d8310f18f0c2a443d.6fb86614.mp4";